class IaBlogTabs extends HTMLElement {
  connectedCallback() {
    this.allUrl = this.dataset.allUrl || window.location.pathname;
    this.tabs = Array.from(this.querySelectorAll("[data-ia-blog-tab]"));
    this.panels = Array.from(this.querySelectorAll("[data-ia-blog-panel]"));
    
    this.bindTabs();
    this.initFromURL();
  }

  bindTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const blogHandle = tab.dataset.blogHandle;
        const blogUrl = tab.dataset.blogUrl;
        this.switchTab(blogHandle, blogUrl);
      });
    });
  }

  initFromURL() {
    const currentPath = window.location.pathname;
    const activeTab = this.tabs.find(tab => {
      const tabUrl = tab.dataset.blogUrl;
      return currentPath === tabUrl || currentPath.startsWith(tabUrl + '/');
    });
    
    if (activeTab) {
      const blogHandle = activeTab.dataset.blogHandle;
      this.switchTab(blogHandle, activeTab.dataset.blogUrl, false);
    }
  }

  switchTab(blogHandle, blogUrl, updateHistory = true) {
    // Update tabs active state
    this.tabs.forEach((tab) => {
      const active = tab.dataset.blogHandle === blogHandle;
      tab.classList.toggle("active", active);
    });

    // Update panels visibility
    this.panels.forEach((panel) => {
      const active = panel.dataset.blogHandle === blogHandle;
      panel.classList.toggle("is-active", active);
      panel.hidden = !active;
    });

    // Update URL path
    if (updateHistory && blogUrl) {
      window.history.pushState({}, "", blogUrl);
    }

    // Dispatch custom event
    this.dispatchEvent(
      new CustomEvent("ia-blog-tabs:changed", {
        bubbles: true,
        detail: { blogHandle, blogUrl },
      })
    );
  }
}

if (!customElements.get("ia-blog-tabs")) {
  customElements.define("ia-blog-tabs", IaBlogTabs);
}
